export default {
  common_button_back: '뒤로',
  common_button_cancel: '취소',
  common_button_next: '다음',
  common_button_no: '아니요',
  common_button_ok: '확인',
  common_button_reset: '재설정',
  common_button_skip: '건너뛰기',
  common_button_yes: '예',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_enterEmail_email: '회사 이메일을 입력해 주십시오.',
  common_enterEmail_title: '이메일',
  common_error_message_cameraNotAllowed: '이 기능을 사용하려면 카메라에 대한 액세스를 허용해야 합니다.',
  common_error_message_ForbiddenException: '권한 부족',
  common_error_message_incorrectEmail: '올바른 이메일 주소를 입력하십시오.',
  common_error_message_invalidCredentials: '죄송합니다! 사용자 이름 및/또는 암호가 잘못되었습니다. 다시 시도하십시오.',
  common_error_message_invalidMobile: '휴대 전화 번호를 입력하십시오.',
  common_error_message_missingField: '필수 필드',
  common_error_message_noInternetConnection: '인터넷 연결이 끊겼습니다. 다시 시도하십시오.',
  common_error_message_unauthorizedAccess: '무단 액세스',
  common_error_message_webServiceWrongConnection: '데이터 전송 중에 오류가 발생했습니다. 다시 시도하십시오.',
  common_error_title: '오류',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_expired_title: 'Account expired',
  common_onboarding_login_button: 'Log in',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_placeholder_optional: '옵션',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_device_footer: '새 키오스크를 만들려면 Proxyclick 웹 앱에 연결하십시오.',
  common_setup_device_locked_content:
    '이 키오스크는 이미 다른 iPad에서 사용 중입니다. 현재 가지고 있는 iPad에서 이 키오스크를 설정하면 다른 장치에서는 비활성화됩니다. 이 iPad에서 키오스크를 설정하시겠습니까?',
  common_setup_device_locked_continue_button: '이 키오스크 설정',
  common_setup_device_locked_title: '키오스크가 이미 사용 중입니다.',
  common_setup_device_multiTenants: '여러 회사',
  common_setup_device_title: '키오스크 선택',
  common_setup_loading_footer: '키오스크를 사용자 지정하려면 Proxyclick 웹 앱에 연결하십시오.',
  common_setup_loading_message: '구성 중...',
  common_setup_loading_title: '키오스크를 설정하는 중입니다...',
  common_setup_location_footer: '새 사이트를 만들려면 Proxyclick 웹 앱에 연결하십시오.',
  common_setup_location_kiosk: '키오스크',
  common_setup_location_kiosks: '키오스크',
  common_setup_location_title: '사이트 선택',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_login_email: '이메일',
  common_setup_login_forgotPassword_button: '암호를 잊어버리셨습니까?',
  common_setup_login_password: '암호',
  common_setup_login_title: 'Proxyclick 계정으로 로그인',
  common_setup_ready_header: '이 iPad를 {0} 키오스크로 설정할 준비가 되셨습니까?',
  common_setup_ready_message: '구성하는 데 몇 분밖에 걸리지 않으며 키오스크가 켜지고 실행되게 됩니다.',
  common_setup_ready_setup_button: '설정',
  common_setup_ready_title: '안녕하세요, {0} 님',
  common_signup_company: '회사',
  common_signup_email: '이메일',
  common_signup_error_name: '이름과 성을 입력하십시오.',
  common_signup_loading_message1:
    'Proxyclick 웹 앱에 연결하여 키오스크를 사용자 지정할 수 있습니다. 모든 세부 정보가 포함된 이메일이 방금 전송되었습니다.',
  common_signup_loading_message2: '웹 사이트에서 체크인 시 배지를 인쇄하도록 프린터를 설정할 수 있습니다.',
  common_signup_loading_message3: '또한 체크인 시 호스트에게 보낼 알림을 활성화할 수 있습니다.',
  common_signup_loading_message4: '그리고 고유한 색상과 환영 그림으로 키오스크를 사용자 지정하십시오.',
  common_signup_loading_title: '계정 설정 중...',
  common_signup_name: '이름',
  common_signup_name_placeholder: '이름 성',
  common_signup_password: '암호',
  common_signup_title: 'Proxyclick에 오신 것을 환영합니다.',
  common_signup_tryFree_button: '제출',
  common_timeout_content: '터치하여 중단',
  common_timeout_title: '홈 화면으로 돌아가기',
  common_tooltip_disable_button: '모든 팁 사용 안 함',
  common_tooltip_gotIt_button: '알겠습니다.',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} 님이 패키지를 배달했음을 알려 주셨습니다.',
  dm_delivery_confirmation_title: '감사합니다!',
  dm_delivery_confirmation_unknownRecipient: '패키지를 전달한 {{Company_Name}} 에게 알리기위한 알림이 전송되었습니다.',
  dm_delivery_recipient_name: '이 패키지는 누구를위한 패키지입니까?',
  dm_delivery_recipient_unknown_button: '모름',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: '귀하가 등록되었습니다!',
  vm_checkin_confirmation_header_withPrint: '배지를 인쇄하는 중입니다.',
  vm_checkin_confirmation_message: '자리에 앉으시기 바랍니다. {{Host_FirstName}} 님이 귀하와 함께 할 것입니다.',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: '감사합니다!',
  vm_checkin_details_companyName: '회사',
  vm_checkin_details_email: '이메일',
  vm_checkin_details_firstname: '이름',
  vm_checkin_details_lastname: '성',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn:
    '체크인을 마무리하는 중에 오류가 발생했습니다. 리셉션에 문의하시기 바랍니다.',
  vm_checkin_flow_company: '회사',
  vm_checkin_flow_duration: 'Visit duration',
  vm_checkin_flow_email: '이메일',
  vm_checkin_flow_error_message_imageNotAvailable: '죄송합니다. 이미지를 현재 사용할 수 없습니다(인터넷 연결 문제).',
  vm_checkin_flow_licensePlate: '번호판',
  vm_checkin_flow_mobile: '휴대 전화 번호를 입력하십시오.',
  vm_checkin_flow_mobile_info: '이것은 시설에있는 동안 긴급 상황 발생시 연락을 취할 때 사용됩니다.',
  vm_checkin_flow_tooltip_content:
    '환경을 개선하거나 체크인을 보다 안전하게 만드는 데 필요한 사항을 방문자에게 물어보십시오. 방문자의 답변에 따라 질문의 흐름을 변경할 수 있습니다. 표시된 질문은 데모용 샘플일 뿐입니다.',
  vm_checkin_flow_tooltip_title: '스마트 질문',
  vm_checkin_host_enterFullName: '호스트의 전체 이름을 입력하십시오.',
  vm_checkin_host_name: '누구를 방문하십니까?',
  vm_checkin_host_notListed_block: '호스트를 모르거나 목록에 없는 경우 리셉션니스트에게 문의하십시오.',
  vm_checkin_host_notListed_continue: '목록에 없음',
  vm_checkin_host_tooltip_content:
    '여기에 이름을 입력하십시오. 그러면 방문자가 도착할 때 알림 이메일이 전송되어 직원이 알 수 있게 됩니다.',
  vm_checkin_host_tooltip_title: '방문자 도착 알림',
  vm_checkin_host_unknown_button: '모름',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Learn more',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: '동의',
  vm_checkin_instructions_clearSignature_button: '지우기',
  vm_checkin_instructions_sendCopy_button: '이메일로 내게 복사본 보내기',
  vm_checkin_instructions_sendCopyTo_button: '복사본이 {0}(변경)에 전송됩니다.',
  vm_checkin_instructions_sign: '손가락으로 여기에 서명',
  vm_checkin_instructions_tooltip_content:
    '간단한 탭 또는 서명으로 게스트가 방문 규칙에 동의하게 하십시오. 방문자 체크인 유형에 따라 약관을 변경할 수 있습니다. Proxyclick 대시보드에서 이 기능 및 기타 여러 기능을 사용자 지정하십시오.',
  vm_checkin_instructions_tooltip_title: '서명되고 봉인됨',
  vm_checkin_method_name: '안녕하세요, 이름이 어떻게 되십니까?',
  vm_checkin_method_name_enterFullName: '전체 이름을 입력하십시오.',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: '목록에 없습니까? 리셉션에서 확인하십시오.',
  vm_checkin_method_name_notRegistered_continue: '목록에 없습니까?',
  vm_checkin_method_tooltip_content:
    '"Justin Diaz"로 체크인하여 재방문하거나 사전 등록된 방문자를 인식하는 방법을 살펴보십시오. \n\n또는 임의의 이름을 입력하여 예기치 않은 방문자를 응대하는 방법을 살펴보십시오.',
  vm_checkin_method_tooltip_title: '방문자 인식',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: '사진 촬영',
  vm_checkin_picture_title: '귀하의 사진을 촬영하겠습니다!',
  vm_checkin_picture_tooltip_content:
    '키오스크를 요구에 맞게 조정하고 방문자 사진 촬영 또는 배지 인쇄 등의 기능을 쉽게 추가하거나 제거할 수 있습니다.',
  vm_checkin_picture_tooltip_title: '선택적 기능',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: "Hello, what's your email address?",
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: '체크인',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: '세부 정보 편집',
  vm_checkin_summary_groupStats: '{0}/{1}명의 사람들이 이미 있습니다.',
  vm_checkin_summary_meetingTime: '{0}에서의 미팅',
  vm_checkin_summary_reviewDetails_button: '내 방문 세부 정보 검토',
  vm_checkin_summary_sendPass_button: '내 스마트폰으로 향후 방문에 대한 패스를 내게 보내기',
  vm_checkin_summary_sendPassTo_button: '영구 패스가 {0}(변경)에 전송됩니다.',
  vm_checkin_summary_takeNewPicture_button: '새로운 사진 촬영',
  vm_checkin_summary_title: '{{Company_Name}} 방문',
  vm_checkin_summary_visiting: '{0} 방문',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: '{{Visitor_FirstName}} 님, 환영합니다!',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',
  vm_checkin_welcome_lastVisit_today: 'Your last visit was earlier today',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_returning: '{{Visitor_FirstName}} 님 다시 오신 것을 환영합니다!',
  vm_checkout_confirmation_header: '{{Visitor_FirstName}} 님, 안녕히 가십시오!',
  vm_checkout_confirmation_message: '체크아웃되었습니다. 즐거운 방문이 되셨기를 바랍니다.',
  vm_checkout_confirmation_title: '방문해 주셔서 감사합니다!',
  vm_checkout_method_name: '체크 아웃 할 이름을 입력하십시오.',
  vm_checkout_method_name_notFound: '찾을 수 없음',
  vm_checkout_method_title: '체크아웃하도록 하겠습니다.',
  vm_identification_id_button: 'ID 스캔',
  vm_identification_qrCode_button: '초대장/패스 스캔',
  vm_infopack_confirmation: '감사합니다! \n{0}에 정보를 보냈습니다.',
  vm_infopack_email: 'Proxyclick에 대한 정보를 보낼 수 있도록 이메일을 입력해 주시기 바랍니다.',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_send_button: '내게 정보 보내기',
  vm_multiTenant_title: '환영합니다. 어느 회사를 방문하십니까?',
  vm_product_footer_learnMore: 'Learn more',
  vm_product_footer_noPartner: "You're using Proxyclick Welcome",
  vm_product_footer_partner: "You're using Proxyclick Welcome, brought to you by {0}",
  vm_qrCode_help: '카메라에서 10-15cm 정도 코드 잡기',
  vm_qrCode_not_recognized: '코드 인식 안 됨',
  vm_qrCode_title: '배지 또는 패스북 코드 스캔',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>방문자 지침 및 기밀 유지 계약</h1><p>환영합니다! 당사 시설에 {{Company_Name}}의 게스트로 오신 것을 환영합니다.</p><h2>보건 및 안전 지침</h2><p>방문하시는 동안 귀하의 개인 안전에 만전을 기하고 있습니다. 따라서 다음을 준수해 주실 것을 요청드립니다.</p><ul><li><b>구내에 접근</b>은 {{Company_Name}} 직원과 동행 시에만 허용됩니다.</li><li>방문자 <b>배지</b>를 항상 착용해야 하며 나갈 때 리셉션에 반환해야 합니다.</li><li><b>응급 상황</b> 발생 시, 모든 방문자는 가장 가까운 안전한 출입구를 통해 즉시 구내를 떠나고 지정된 어셈블리 지점에 보고해야 합니다.</li><li>방문자는 구내 내부 또는 주변 시설 부지를 포함한 어떤 곳의 <b>이미지도 캡처해서는 안 됩니다.</b>(사진 및 동영상)</li><li>건물 내 <b>흡연은 엄격히 금지됩니다.</b></li></ul><h2>기밀 유지 계약</h2><p>{{Company_Name}}의 시설 방문 시, 대중에 일반적으로 알려지지 않은 (기술, 프로세스, 장비, 도면 및 사양과 관련한 정보를 포함하되 이에 제한되지 않은) 부동산 또는 기밀 정보(이하에 통칭하여 &#34;기밀 정보&#34;라 함)에 대해 알게 되거나 볼 수 있습니다.</p><p>{{Company_Name}}의 시설 방문 권한을 고려하여 그리고 방문 중에 귀하에게 제공되는 예우를 위해, 귀하는 다음을 따르는 데 동의합니다.</p><p>(a) 이번 방문 및 이후 방문 중에 귀하에게 공개된 기밀 정보를 어느 누구에게도 공개하거나 제공하지 않습니다. 또는</p><p>(b) 어떠한 방식으로든 기밀 정보를 사용하거나 추가로 밝히기 위해 다른 이들을 이용하거나 지원하지 않습니다.</p><p>(c) 카메라나 비디오 기술을 사용하여 기밀 정보를 공개하지 않습니다.</p><p>시설에 서명함으로써 게시된 보건 및 안전 지침과 기밀 유지 계약을 인정하고 이해하는 것입니다.</p>',
  vm_signup_defaultInstruction_name: '모든 방문자들이 서명할 지침',
  vm_signup_defaultInstruction_title: '읽은 후 아래에 서명하십시오.',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: '체크인',
  vm_welcome_checkout_button: '체크아웃',
  vm_welcome_delivery_button: 'Delivery',
  vm_welcome_hello_line1: '안녕하세요,',
  vm_welcome_hello_line2: '{{Company_Name}} 에 오신 것을 환영합니다.',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Been here before?',
  vm_welcome_title: '{{Company_Name}}에 오신 것을 환영합니다.',
  vm_welcome_tooltip_content:
    '키오스크를 맞춤화하려면 Proxyclick 웹 앱에 로그인하십시오. 지침이 포함된 이메일이 방금 전송되었습니다. 웹 앱에서 귀사의 로고, 배경 이미지를 업로드하고 색상을 선택하여 귀사의 브랜드 정체성이 키오스크에 반영되게 할 수 있습니다.',
  vm_welcome_tooltip_title: '맞춤화하기',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: '또는',
};
